import React from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import ChatBox from '../../Chat/ChatBox';



const ChatPage = (props) => {
  return (
    <div>
      <Header {...props} authUser={props.authUser} />
      <ChatBox />
      <Footer />
    </div>
  );
};

export default ChatPage;